import { render, staticRenderFns } from "./TrainingRecords.vue?vue&type=template&id=00e1c539"
import script from "./TrainingRecords.vue?vue&type=script&lang=ts"
export * from "./TrainingRecords.vue?vue&type=script&lang=ts"
import style0 from "./TrainingRecords.vue?vue&type=style&index=0&id=00e1c539&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports